import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { createContext } from "react";

export interface GridSelectionState {
  checked: boolean;
  indeterminate: boolean;
  onChange: (checked: boolean) => void;
  isRowSelectionDisabled: (params: GridRenderCellParams) => boolean;
}

const GridSelectionContext = createContext<GridSelectionState | undefined>(undefined);

export default GridSelectionContext;
